/* Ezspa announcements and the native cookie-preferences link.
   Dawn owns the navigation and cart. */
(function(){
 'use strict';
 function init(){
  document.querySelectorAll('[data-ezspa-announcements]').forEach(function(bar){
   if(bar.dataset.ready)return;bar.dataset.ready='true';
   var slides=Array.from(bar.querySelectorAll('.announcement-slider__slide'));
   var button=bar.querySelector('[data-ezspa-announcement-pause]');
   var reduced=matchMedia('(prefers-reduced-motion:reduce)').matches;
   var paused=reduced,index=0,timer;
   function draw(){slides.forEach(function(slide,i){slide.hidden=i!==index;});}
   function setButton(){if(!button)return;button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.play:button.dataset.pause);button.textContent=paused?'▶':'Ⅱ';}
   function start(){clearInterval(timer);if(paused||slides.length<2)return;timer=setInterval(function(){if(document.hidden||bar.matches(':focus-within,:hover'))return;index=(index+1)%slides.length;draw();},10000);}
   if(button)button.addEventListener('click',function(){paused=!paused;setButton();start();});
   draw();setButton();start();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();

/* Reopen Shopify's configured banner without changing the visitor's consent. */
document.addEventListener('click',function(event){
 var link=event.target.closest ? event.target.closest('a[href$="#cookievoorkeuren"]') : null;
 if(!link)return;
 if(window.privacyBanner && typeof window.privacyBanner.showPreferences==='function'){
  event.preventDefault();
  Promise.resolve(window.privacyBanner.showPreferences()).catch(function(){
   // Keep a useful destination if Shopify's privacy service is unavailable.
   location.assign(link.href);
  });
 }
});
